import React, { useId, useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { useWideLayout } from '../useWideLayout';

export default function Disclosure({ title, summary, area, children }) {
  const wide = useWideLayout();
  const [open, setOpen] = useState(false);
  const panelId = useId();
  const expanded = wide || open;

  return (
    <section className="crm-card crm-disclosure" data-area={area}>
      {wide ? (
        <h2>{title}</h2>
      ) : (
        <button
          type="button"
          className="crm-disclosure-toggle"
          aria-expanded={open}
          aria-controls={panelId}
          onClick={() => setOpen(!open)}
        >
          <span className="crm-disclosure-title">{title}</span>
          <span className="crm-disclosure-summary">{summary}</span>
          <ChevronDown size={18} className={`crm-chevron${open ? ' open' : ''}`} aria-hidden="true" />
        </button>
      )}
      <div id={panelId} className="crm-disclosure-panel" hidden={!expanded}>
        {children}
      </div>
    </section>
  );
}
